/**
 * 快照间运动学插值（设计文档 D4 / 3.6）。
 *
 * 轿厢在运行段内的位置由运动学曲线精确求得（非线性插值），
 * 与内核到层时刻共用同一 kinematics 实现（AC-F015-01/AC-F012-02）。
 */
import { positionAt } from '../core/physics/kinematics';
import type { KinematicsParams } from '../core/physics/kinematics';
import type { CarSnapshot } from '../core/snapshot';

/**
 * 轿厢在 simMs 时刻的小数楼层。
 * - 非运行态或已过段尾：停在逻辑楼层；
 * - 运行段内：按梯形速度曲线插值。
 */
export function interpolatedFloor(car: CarSnapshot, simMs: number, kin: KinematicsParams): number {
  if (car.state !== 'moving') return car.floor;
  if (simMs >= car.segEndMs) return car.segToFloor;
  if (simMs <= car.segStartMs) return car.segFromFloor;
  const gap = Math.abs(car.segToFloor - car.segFromFloor);
  const d = gap * kin.floorHeight; // 米
  const elapsedSec = (simMs - car.segStartMs) / 1000;
  const posMeters = positionAt(d, elapsedSec, kin);
  const floors = posMeters / kin.floorHeight;
  return car.segFromFloor < car.segToFloor ? car.segFromFloor + floors : car.segFromFloor - floors;
}
